import styled from 'styled-components'

export const StyledActivateWrapper = styled.div`
  .lon-activate {
    width: 335px;
    padding: 80px 0;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position-y: 45px;

    .code-inputs-wrap {
      display: flex !important;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .code-inputs {
        display: flex !important;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        input {
          background: white;
          border: 0.5px solid #eaecf6;
          border-radius: 8px;
          height: 75px;
          line-height: 75px;
          font-size: 21px;
          max-width: 55px;
          color: #43454f;
          text-align: center;
          outline: none;
          flex: 1;
        }
      }
    }

    .label {
      font-weight: 500;
      font-size: 13px;
      color: #9598ab;
      margin-bottom: 10px;
    }

    .wallet-address-wrap {
      background: white;
      height: auto;
      border: 0.5px solid rgba(234, 236, 246, 0.2);
      border-radius: 8px;
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      flex-flow: row nowrap;
      align-items: center;
      padding: 16px 8px 20px 20px;

      p {
        font-size: 15px;
        line-height: 18px;
        resize: none;
        word-break: break-all;
      }

      img {
        padding: 8px;
        user-select: none;
        cursor: pointer;
      }
    }

    .activate-button-wrap {
      padding: 10px 0 20px;
      margin-top: 30px;

      button {
        line-height: 45px;
        background: #eaecf6;
        border: 0.5px solid rgba(234, 236, 246, 0.2);
        font-size: 17px;
        text-align: center;
        color: white;
        border-radius: 25px;
        width: 100%;
        outline: none;
        cursor: pointer;

        &.active {
          background: #5f4dbc;
          color: white;
        }
      }
    }

    .activate-result {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      padding-top: 0px;

      button {
        line-height: 45px;
        border: 0.5px solid rgba(234, 236, 246, 0.2);
        font-size: 17px;
        text-align: center;
        background: #5f5fab;
        color: white;
        border-radius: 25px;
        width: 215px;
        outline: none;
        margin-top: 20px;
      }

      .title {
        font-size: 17px;
        line-height: 24px;
        margin: 5px 0;
        color: #43454f;
      }

      .subtitle {
        font-size: 13px;
        line-height: 20px;
        color: #777a8c;
        margin: 5px 0;
      }
    }
  }
  @media screen and (max-width: 960px) {
    .lon-activate {
      width: 100%;
      height: 100vh;
      padding: 30px 20px;
      box-sizing: border-box;
      background-position-y: 5px;

      .code-inputs-wrap {
        width: 100%;
      }

      .activate-button-wrap {
        position: fixed;
        width: 100%;
        left: 0;
        bottom: 0;
        background: white;
        padding: 10px 20px;
        box-sizing: border-box;
      }

      .activate-result {
        padding-top: 100px;
      }
    }
    .exchange-header-wrap {
      display: none;
    }

    .footer-wrap {
      display: none;
    }
  }
`

export const StyledActivateModal = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`
